module.exports = __webpack_public_path__ + "img/ico_shop_confirm.68aadc33.svg";